import * as React from 'react';
import styled, { css } from 'styled-components';

import { size } from '../layout/helpers';

const checkboxSize = size(2);
const textSize = '1rem';
const textLineHeight = '1.5';

export const Label = styled.label`
  position: relative;
  display: flex;
  align-items: flex-start;
  font-size: ${textSize};
  line-height: ${textLineHeight};
  user-select: none;
  cursor: default;

  &::before {
    content: '';
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: ${checkboxSize};
    height: ${checkboxSize};
    margin-top: calc((${checkboxSize} - ${textSize} * ${textLineHeight}) / -2);
    background-color: var(--bg-body, ${(props) => props.theme.color.bg});
    border: 1px solid ${(props) => props.theme.color.borderAlt};
    font-size: 1rem;
    border-radius: 3px;
    cursor: pointer;
  }
`;

export const LabelText = styled.div`
  flex: 1 1 auto;
  margin-left: ${size(1)};
  overflow: hidden; // Hide overflow from nested Columns
`;

export const Wrapper = styled.div<{ error?: boolean }>`
  ${({ error }) =>
    error &&
    css`
      ${Label} {
        color: ${(props) => props.theme.color.ui.negative};

        &::before {
          background-color: ${(props) => props.theme.color.ui.negativeLight};
        }
      }
    `}
`;

export const Input = styled((props) => (
  <input {...props} className={`${props.checked ? 'checked' : undefined} ${props.className}`} />
)).attrs(({ type, checked }) => ({
  checked,
  type: type || 'checkbox',
}))`
  position: fixed;
  left: -9999px;
  opacity: 0;

  &[disabled] {
    & + ${Label} {
      opacity: 0.37;
      cursor: not-allowed;
    }
  }

  &:checked,
  &.checked {
    & + ${Label} {
      &::before {
        border-color: var(--element-color, ${(props) => props.theme.color.primary});
        background-color: var(--element-color, ${(props) => props.theme.color.primary});
        mask-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path d="M0 0v16h16V0H0zm12.8 5.7L7 11.5c-.3.3-.8.3-1.2 0L3.2 9c-.3-.3-.3-.8 0-1.2.3-.3.8-.3 1.2 0l1.9 1.9 5.2-5.2c.3-.3.8-.3 1.2 0s.4.8.1 1.2z"/></svg>');
        mask-size: 100%;
      }
    }
  }

  &:focus,
  &:focus-visible {
    & + ${Label} {
      &::before {
        outline: 0.125rem solid var(--color-border-focus, #1959ca);
        outline-offset: var(--focus-outline-offset, 0.125rem);
      }
    }
  }
`;
